module.exports = __webpack_public_path__ + "img/inbox.0c67a6f2.svg";